function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M2.55 2.55C2.91 2.2 3.4 2 3.9 2h9.63a1.89 1.89 0 011.89 1.89v9.63a1.89 1.89 0 01-1.9 1.89H3.9A1.89 1.89 0 012 13.5V3.9c0-.5.2-.98.55-1.34zm1.34 1a.33.33 0 00-.33.34v9.63a.33.33 0 00.33.33h9.63a.33.33 0 00.33-.33V3.89a.33.33 0 00-.33-.33H3.89z",
  clipRule: "evenodd"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M17.22 4.96c.43 0 .78.35.78.78v10.74A1.52 1.52 0 0116.48 18H5.74a.78.78 0 110-1.56h10.7V5.74c0-.43.35-.78.78-.78zm-5 1.23c.3.3.3.8 0 1.1l-3.7 3.81c-.3.3-.77.32-1.08.03L5.22 9.08a.78.78 0 011.05-1.14l1.66 1.53 3.18-3.27c.3-.3.8-.31 1.1-.01z",
  clipRule: "evenodd"
});

function SvgSelection(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelection);
export default __webpack_public_path__ + "static/media/selection.228240f8.svg";
export { ForwardRef as ReactComponent };